import type { IntlService } from 'ember-intl';
import type HotelAndMarketService from 'lumen/services/hotel-and-market';
import { RECOMMENDATION_RATE_DIFFERENCE_FORMATS } from 'lumen/utils/constants/pricing-assistant-constants';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, max-params
export function formatDifferenceBetweenRecommendationAndOwnRate(
  intl: IntlService,
  recommendationValue: number,
  ownRateValue: number,
  format: string, // format for difference between rates & recommendations
  hotelAndMarketService: HotelAndMarketService, // needs to be passed to be able to use formatRate in case of absolute formatting
) {
  let differenceToReturn = null;
  let formattedDifference = null;
  const MINIMUM_PERCENTAGE_THRESHOLD = 0.5;
  const differenceBetweenRecommendationAndOwnRate =
    recommendationValue - ownRateValue;

  if (format === RECOMMENDATION_RATE_DIFFERENCE_FORMATS.ABSOLUTE) {
    differenceToReturn = Math.round(differenceBetweenRecommendationAndOwnRate);

    formattedDifference = hotelAndMarketService.formatRate(differenceToReturn, {
      includeSign: true,
    });
  } else {
    const differenceAsPercentage =
      differenceBetweenRecommendationAndOwnRate / ownRateValue;

    differenceToReturn = Math.round(differenceAsPercentage * 10000) / 100; // Multiply by 10000 and divide by 100 to preserve 2 decimal places
    const zeroPercentFormat =
      differenceBetweenRecommendationAndOwnRate < 0 ? '-0%' : '+0%';
    formattedDifference =
      Math.abs(differenceToReturn) < MINIMUM_PERCENTAGE_THRESHOLD
        ? zeroPercentFormat
        : intl.formatNumber(differenceToReturn / 100, {
            style: 'percent',
            signDisplay: 'always',
          });
  }

  return {
    difference: differenceToReturn,
    absoluteDifference: Math.abs(differenceToReturn),
    formattedDifference,
    isPositiveDifference: differenceBetweenRecommendationAndOwnRate > 0,
  };
}
